module.exports = __webpack_public_path__ + "img/business2.ccdf6293.jpg";